import { render, staticRenderFns } from "./ModalActions.vue?vue&type=template&id=415f2c74"
import script from "./ModalActions.vue?vue&type=script&lang=js"
export * from "./ModalActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports